import React from 'react'
import styled from 'styled-components'
import { Button, Layout } from '@staccx/bento'
import Alert from '../../../components/Alert'
import { TranslatedText } from '@staccx/i18n'
import { loggedoutReasons } from '../../../constants/statusMessages'
import Logo from '../../../icons/Logo'

const loggedoutReason = sessionStorage.getItem('loggedoutReason')

const LoginChoice = () => {
  const handleOnClick = (type) => {
    sessionStorage.setItem('type', type)
    switch (type) {
      case 'sms':
        window.location.href = '/loginsms'
        break
      case 'email':
        window.location.href = '/loginemail'
        break
      case 'username':
        window.location.href = '/loginusername'
        break
    }
  }
  return (
    <React.Fragment>
      <Layout style={{ maxWidth: '400px' }}>
        <Center>
          <Logo />
        </Center>{' '}
        <Button onClick={() => handleOnClick('sms')}>
          <TranslatedText i18nKey="LOGIN_WITH_SMS" />
        </Button>
        <Button onClick={() => handleOnClick('email')}>
          <TranslatedText i18nKey="LOGIN_WITH_EMAIL" />
        </Button>
        <Button onClick={() => handleOnClick('username')}>
          Logg inn med brukernavn
        </Button>
        <LoggedoutReason />
      </Layout>
    </React.Fragment>
  )
}

const LoggedoutReason = () => {
  switch (loggedoutReason) {
    case loggedoutReasons.UNKNOWN_USER:
      return (
        <TranslatedText i18nKey={loggedoutReason}>{(value) => <Alert type={'warning'}>{value}</Alert>}</TranslatedText>
      )

    case loggedoutReasons.NORMAL_LOGOUT:
      return (
        <TranslatedText i18nKey={loggedoutReason}>{(value) => <Alert type={'info'}>{value}</Alert>}</TranslatedText>
      )

    default:
      return null
  }
}

const Center = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  width: 100%;
`

LoginChoice.propTypes = {}

export default LoginChoice
